
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import InlineLoading from 'vux/src/components/inline-loading/index.vue'
import ViewBox from 'vux/src/components/view-box/index.vue'
import Swiper from 'vux/src/components/swiper/swiper.vue'
import SwiperItem from 'vux/src/components/swiper/swiper-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Popup from 'vux/src/components/popup/index.vue'

import wx from 'weixin-jsapi'
import { mapState, mapGetters } from 'vuex';

export default {
name: 'ProductCenter',
data() {
return {
showPopup: false,
playstatus: true,
defaultImg: 'this.src="' + require('../assets/product/prod/1.png') + '"',
defaultImg2: 'this.src="' + require('../assets/product/prod_detail/bangde.jpg') + '"',
message: '',
showMsg: [],
swiperList: [],
videoList: [],
show: false,
showList1: true,
categoryList: [],
categoryDetailList: [],
categoryId: '',
code: null,
loading: true,
isSLogin: ''
}
},
directives: {
TransferDom
},
components: {
InlineLoading,
Flexbox,
FlexboxItem,
Group,
Cell,
Popup,
Swiper,
SwiperItem,
ViewBox
},
computed: {
...mapGetters(['thirdParty']),
},
created() {
this.login()
},
mounted() {
this.queryProductCategory()
this.queryProductByName()
this.queryWanderFulAdvert()
this.queryRotaryAdvert()
},
watch: {
$route(to, from) {
if (from.name === 'ProductDetail' && to.name === 'ProductCenter') {
this.getCategory(this.$route.params.categoryId)
}
}
},
methods: {
scanQRCode() {
if (this.code) {
let _this = this
wx.scanQRCode({
desc: 'scanQRCode desc',
needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
scanType: ['qrCode', 'barCode'], // 可以指定扫二维码还是一维码，默认二者都有
success: function(res) {
let result = res.resultStr 
if (result.includes(',')) {
result = result.split(',')[1]
}
_this.queryProductDetailByBarcode(result)
}
})
} else {
this.$Message['warning']({
background: true,
content: '该功能仅限微信端使用'
})
}
},
getQueryVariable(variable) {
let query = window.location.search.substring(1)
let vars = query.split('&')
for (let i = 0; i < vars.length; i++) {
let pair = vars[i].split('=')
if (pair[0] == variable) {
return pair[1]
}
}
return false
},
login() {
let query = window.location.href.split('?')[1]
if (query && query.indexOf('official') > -1) {
sessionStorage.setItem('official', 'official')
this.isSLogin = 'official'
} else {
this.isSLogin = sessionStorage.getItem('official')
}
if (query && query.indexOf('categoryId') > -1) {
let prods = query.split('&')
let categoryId = prods[0].split('=')[1]
if (query.indexOf('prodId') > -1) {
let prodId = prods[1].split('=')[1]
this.queryProductDetailById(categoryId, prodId)
} else {
this.categoryId = categoryId
}
} else {
this.code = this.getQueryVariable('code')
let tarUrl = window.location.href.split('#')[0]
if (this.code) {
let url = `${this.API_ROOT}login`
this.$http({
method: 'get',
url: url,
params: {
code: this.code,
targetUrl: tarUrl
}
}).then(
function(res) {
sessionStorage.setItem('userId', res.data.userId)
wx.config({
debug: false, // 开启调试模式,
appId: res.data.appId, // 必填，企业号的唯一标识，此处填写企业号corpid
timestamp: res.data.timestamp, // 必填，生成签名的时间戳
nonceStr: res.data.nonceStr, // 必填，生成签名的随机串
signature: res.data.signature, // 必填，签名，见附录1
jsApiList: ['scanQRCode'] 
})
},
function(er) {
alert(er)
}
)
} else {

}
}
},
queryRotaryAdvert() {
let url = `${this.API_ROOT}queryRotaryAdvert`
this.$http({
method: 'get',
url: url,
params: {
status: this.isSLogin
}
}).then(
res => {
if (res.data.datas) {
res.data.datas.map(item => {
if (item.picturePathMobile) {
this.swiperList.push({ img: item.picturePathMobile, url: item.url, fallbackImg: require('../assets/product/swipe/defaultImg.png') })
}
})
}
},
er => {
console.log(er)
alert('轮播请求失败')
}
)
},
queryProductCategory() {
let url = `${this.API_ROOT}queryProductCategory`
this.$http({
method: 'get',
url: url,
params: {
status: this.isSLogin
}
}).then(
res => {
if (res.data.datas) {
this.categoryList = res.data.datas

} else {
alert('产品分类数据异常')
}
},
er => {
console.log(er)
alert('请求失败')
}
)
},
queryProductByName(prodName) {
let url = `${this.API_ROOT}queryProductByName`
let data = { status: this.isSLogin }
if (prodName) {
data.prodName = prodName
}
this.$http({
method: 'get',
url: url,
params: data
}).then(
res => {
if (prodName) {
this.showMsg = res.data.datas
} else {
this.categoryDetailList = res.data.datas
if (this.categoryId) {
this.$nextTick(() => {
this.getCategory(this.categoryId)
})
}
this.loading = false
}
},
er => {
console.log(er)
}
)
},
queryWanderFulAdvert() {
let url = `${this.API_ROOT}queryWanderFulAdvert`
this.$http({
method: 'get',
url: url,
params: {
status: this.isSLogin
}
}).then(
res => {
this.videoList = res.data.datas

},
er => {
console.log(er)
alert('请求失败')
}
)
},

/*
*点击轮播图
*/
showImgDetail(item) {
console.log('url:', item)
if (item.url) {
let Category = item.url.split('@')
this.queryProductDetailById(Category[0], Category[1])
}
},
queryProductDetailById(categoryId, prodId) {
let url = `${this.API_ROOT}queryProductDetailById`
let userId = sessionStorage.getItem('userId')
this.$http({
method: 'get',
url: url,
params: {
categoryId: categoryId,
prodId: prodId,
userId: userId
}
}).then(
res => {
if (res.data.mapDatas) {
const paramData = {...res.data.mapDatas, thirdParty: this.thirdParty || 0 }
this.$router.push({ name: 'ProductDetail', params: paramData })
} else {
alert('返回数据为空,请联系管理员检查')
}
},
er => {
console.log(er)
alert('请求失败')
}
)
},
queryProductDetailByBarcode(barcode) {
let url = `${this.API_ROOT}queryProductDetailByBarcode`
this.$http({
method: 'get',
url: url,
params: {
barcode: barcode
}
}).then(
res => {
if (res.data.mapDatas) {
this.$router.push({ name: 'ProductDetail', params: res.data.mapDatas })
} else {
alert('返回数据为空,请联系管理员检查')
}
},
er => {
console.log(er)
}
)
},
showSearch() {
this.showPopup = true
this.$nextTick(() => {
this.$refs.searchProd.focus()
})
},
searchProd() {
if (this.message) {
this.queryProductByName(this.message)
} else {
this.showMsg = []
}
},
searchProd2(ev) {
if (ev.keyCode == 13) {
if (this.showMsg.length > 0 && this.showMsg[0].prodName === this.message) {
this.getProdDetail(this.showMsg[0].categoryId, this.showMsg[0].prodId)
} else {
if (this.message) {
this.showMsg = []
alert('查无数据！')
} else {
alert('请输入要查询的数据！')
}
}
}
},
cancelSearch() {
this.showMsg = []
this.showPopup = false
this.message = null
},
getCategory(code) {
if (code) {
document.getElementById(code).scrollIntoView()
}
},
getProdDetail(categoryId, prodId) {
this.showMsg = []
this.showPopup = false
this.message = null
this.queryProductDetailById(categoryId, prodId)
},
gotoPictureShow(index) {
if (index == '1') {
this.$router.push({ name: 'PictureShow', params: { img: 'hotkid.jpg' } })
} else if (index == '2') {
this.$router.push({ name: 'PictureShow', params: { img: 'wangxing.jpg' } })
} else if (index == '3') {
this.$router.push({ name: 'PictureShow', params: { img: 'mum-mum.jpg' } })
} else {
window.location.href = 'https://www.hotkidclub.com/cpn/ceo-intro/?utm_campaign=CEO_WEIXIN_ONLINE&utm_source=CEO_WEIXIN&utm_medium=SUBSCRIBE'
}
},
gotoMoreAd() {
location.href = 'http://mweb.want-want.com/ProductCenter/productController/wonderfulADS.do'

}
},
beforeRouteEnter(to, from, next) {
to.meta.keepAlive = true
next()
},
beforeRouteLeave(to, from, next) {
if (to.name == 'ProductDetail' || to.name == 'PictureShow') {
from.meta.keepAlive = true
to.meta.keepAlive = false
next()
}
}
}



// WEBPACK FOOTER //
// ./src/components/ProductCenter.vue